import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const FolderUpIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.026 19.7118L4.77382 19.7118C3.44833 19.7118 2.37381 18.6373 2.37383 17.3118L2.37392 8.18749C2.37392 7.27356 2.37358 5.97183 2.37329 5.02928C2.37309 4.36636 2.91042 3.82959 3.57334 3.82959H9.29155L12.0566 6.78323H20.3729C21.0356 6.78323 21.5729 7.32048 21.5729 7.98323V11.1708M16.8268 16.6134L19.2811 14.1708M19.2811 14.1708L21.6268 16.503M19.2811 14.1708V20.1708"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

FolderUpIcon.displayName = 'FolderUpIcon';
